import api from './api';

// ===========================================
// BRAND MANAGEMENT API ENDPOINTS
// ===========================================

// Brand CRUD operations
export const getBrands = async (params = {}) => {
  try {
    const response = await api.get('/admin/brands/', { params });
    const data = response.data;
    
    // Transform API response to match frontend expectations
    return {
      success: true,
      data: data.results || [],
      count: data.count || 0,
      next: data.next,
      previous: data.previous
    };
  } catch (error) {
    console.error('Error fetching brands:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch brands',
      data: [],
      count: 0
    };
  }
};

export const getBrand = async (id) => {
  const response = await api.get(`/admin/brands/${id}/`);
  return {
    success: true,
    data: response.data
  };
};

export const createBrand = async (brandData) => {
  const response = await api.post('/admin/brands/', brandData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {
    success: true,
    data: response.data
  };
};

export const updateBrand = async (id, brandData) => {
  const response = await api.put(`/admin/brands/${id}/`, brandData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {
    success: true,
    data: response.data
  };
};

export const partialUpdateBrand = async (id, brandData) => {
  const response = await api.patch(`/admin/brands/${id}/`, brandData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {
    success: true,
    data: response.data
  };
};

export const deleteBrand = async (id) => {
  const response = await api.delete(`/admin/brands/${id}/`);
  return {
    success: true,
    data: response.data
  };
};

// Brand statistics and filtering
export const getBrandStatistics = async () => {
  const response = await api.get('/admin/brand-statistics/');
  return {
    success: true,
    data: response.data
  };
};

export const getBrandsByCategory = async (categoryId) => {
  const response = await api.get(`/admin/brands/by_category/?category_id=${categoryId}`);
  return {
    success: true,
    data: response.data
  };
};

export const getOfficialBrands = async () => {
  const response = await api.get('/admin/brands/official/');
  return {
    success: true,
    data: response.data
  };
};

export const getGenericBrands = async () => {
  const response = await api.get('/admin/brands/generic/');
  return {
    success: true,
    data: response.data
  };
};

// Brand category management
export const assignCategoriesToBrand = async (brandId, categoryIds) => {
  const response = await api.post(`/admin/brands/${brandId}/assign_categories/`, {
    category_ids: categoryIds,
  });
  return {
    success: true,
    data: response.data
  };
};

export const removeCategoriesFromBrand = async (brandId, categoryIds) => {
  const response = await api.post(`/admin/brands/${brandId}/remove_categories/`, {
    category_ids: categoryIds,
  });
  return {
    success: true,
    data: response.data
  };
};

// ===========================================
// BRAND REQUEST API ENDPOINTS
// ===========================================

// Brand Request CRUD operations
export const getBrandRequests = async (params = {}) => {
  try {
    const response = await api.get('/admin/brand-requests/', { params });
    const data = response.data;
    
    // Transform API response to match frontend expectations
    return {
      success: true,
      data: data.results || [],
      count: data.count || 0,
      next: data.next,
      previous: data.previous
    };
  } catch (error) {
    console.error('Error fetching brand requests:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch brand requests',
      data: [],
      count: 0
    };
  }
};

export const getBrandRequest = async (id) => {
  const response = await api.get(`/admin/brand-requests/${id}/`);
  return {
    success: true,
    data: response.data
  };
};

export const createBrandRequest = async (requestData) => {
  const response = await api.post('/admin/brand-requests/', requestData);
  return {
    success: true,
    data: response.data
  };
};

export const updateBrandRequest = async (id, requestData) => {
  const response = await api.put(`/admin/brand-requests/${id}/`, requestData);
  return {
    success: true,
    data: response.data
  };
};

export const deleteBrandRequest = async (id) => {
  const response = await api.delete(`/admin/brand-requests/${id}/`);
  return {
    success: true,
    data: response.data
  };
};

// Brand Request approval/rejection
export const approveBrandRequest = async (id) => {
  const response = await api.put(`/admin/brand-requests/${id}/approve/`);
  return {
    success: true,
    data: response.data
  };
};

export const rejectBrandRequest = async (id, reason) => {
  const response = await api.put(`/admin/brand-requests/${id}/reject/`, {
    rejection_reason: reason
  });
  return {
    success: true,
    data: response.data
  };
};

// Brand Request statistics
export const getBrandRequestStatistics = async () => {
  const response = await api.get('/admin/brand-requests/statistics/');
  return {
    success: true,
    data: response.data
  };
};